export const ticketNavBar = [
    {
      text: "Support",
      icon: "mdi-alert-circle-outline",
      to: "/support",
  
    },
  ];
  